import type { Diamond } from '../api/types'

/**
 * Stone identity for React keys and stone-scoped ops. TagNos (stockId) are NOT
 * unique — one TagNo can be several distinct physical stones — so prefer the
 * numeric `uniqueId`, falling back to stockId for legacy / bundled sample data
 * that predates the re-key.
 */
export function stoneKey(stone: Pick<Diamond, 'uniqueId' | 'stockId'>): string {
  return stone.uniqueId != null ? String(stone.uniqueId) : stone.stockId
}
